const getDefaultState = () => ({
  modalType: "",
});

export default {
  namespaced: true,
  state: () => getDefaultState(),
  actions: {
    modalType({ commit }, payload) {
      commit("modalType", payload);
    },
    resetState({ commit }) {
      commit("resetState");
    },
  },
  mutations: {
    modalType(state, payload) {
      state.modalType = payload;
    },
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
  },
  getters: {
    modalType(state) {
      return state.modalType;
    },
  },
};
